import React, {
  useCallback,
  useEffect,
  useMemo,
  useState
} from 'react';
import axios from 'axios';

import { useSettings } from '../contexts/SettingsContext';
import PixFacilitadoView from './PixFacilitadoView';

const API = (
  process.env.REACT_APP_API_URL ||
  'http://187.127.34.239:4001/api'
).replace(/\/$/, '');

export default function PixFacilitado() {
  const { darkMode } = useSettings();

  const [data, setData] = useState([]);
  const [resumo, setResumo] = useState({
    total: 0,
    em_aberto: 0,
    aguardando_vencimento: 0,
    vencem_hoje: 0,
    atrasados: 0,
    quitados: 0,
    atendimento_humano: 0,
    valor_em_aberto: 0,
    valor_quitado: 0
  });

  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('TODOS');
  const [search, setSearch] = useState('');

  const carregar = useCallback(async () => {
    setLoading(true);

    try {
      const resposta = await axios.get(
        `${API}/crm/pix-facilitado`
      );

      setData(resposta.data?.data || []);
      setResumo(resposta.data?.resumo || {});
    } catch (error) {
      console.error(
        'Erro ao carregar PIX Facilitado:',
        error
      );

      setData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    carregar();
  }, [carregar]);

  const dadosFiltrados = useMemo(() => {
    const busca = search.trim().toLowerCase();

    return data.filter(item => {
      const correspondeStatus =
        filtro === 'TODOS' ||
        item.status_operacional === filtro;

      const correspondeBusca =
        !busca ||
        String(item.nome || '')
          .toLowerCase()
          .includes(busca) ||
        String(
          item.phone ||
          item.whatsapp_number ||
          ''
        ).includes(search.trim()) ||
        String(item.cpf_cnpj || '')
          .includes(search.trim());

      return correspondeStatus && correspondeBusca;
    });
  }, [data, filtro, search]);

  const bg = darkMode ? '#111827' : '#F3F4F6';
  const txt = darkMode ? '#F9FAFB' : '#111827';
  const sub = darkMode ? '#9CA3AF' : '#6B7280';

  return (
    <div style={{
      minHeight: '100vh',
      background: bg,
      padding: '24px 20px',
      boxSizing: 'border-box'
    }}>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{
          fontSize: 24,
          fontWeight: 800,
          color: txt,
          margin: 0
        }}>
          PIX Facilitado
        </h1>

        <p style={{
          color: sub,
          margin: '4px 0 0',
          fontSize: 14
        }}>
          Controle da 2ª parcela e régua de cobrança
        </p>
      </div>

      <div style={{ marginBottom: 20 }}>
        <input
          value={search}
          onChange={event =>
            setSearch(event.target.value)
          }
          placeholder="🔍 Buscar por nome, telefone ou CPF…"
          style={{
            width: '100%',
            maxWidth: 380,
            padding: '9px 14px',
            borderRadius: 8,
            outline: 'none',
            border: `1px solid ${
              darkMode ? '#374151' : '#D1D5DB'
            }`,
            background:
              darkMode ? '#1F2937' : '#FFFFFF',
            color: txt,
            fontSize: 14
          }}
        />
      </div>

      <PixFacilitadoView
        darkMode={darkMode}
        data={dadosFiltrados}
        resumo={resumo}
        loading={loading}
        filtro={filtro}
        setFiltro={setFiltro}
        onRefresh={carregar}
      />
    </div>
  );
}
